<script lang="ts">
	import image3Sm from "@assets/images/carousel-images/2.jpg?webp&w=250&imagetools";
	import image3Lg from "@assets/images/carousel-images/2.jpg?webp&w=500&imagetools";
	import image1Sm from "@assets/images/hero/3.png?webp&w=250&imagetools";
	import image1Lg from "@assets/images/hero/3.png?webp&w=500&imagetools";
	import image2Sm from "@assets/images/hero/4.png?webp&w=250&imagetools";
	import image2Lg from "@assets/images/hero/4.png?webp&w=500&imagetools";
	import Media from "@components/common/Media.svelte";
	import calendarIcon from "@core/assets/icons/calendar.svg?raw";
	import couchIcon from "@core/assets/icons/couch.svg?raw";
	import Formatted from "../common/Formatted.svelte";
	import Link from "../common/Link.svelte";
	import { ButtonVariant } from "../common/getButtonClass.js";

	const {
		style = "booking",
	}: {
		style: "booking" | "voucher";
	} = $props();

	interface Step {
		step: string;
		heading: string;
		text?: string;
	}

	const bookingHeader = "Jak zažít head spa napohodu?";
	const bookingSteps: Step[] = [
		{
			step: "KROK 1",
			heading: "PŘED PROCEDUROU",
			text: "Rezervuj si svůj termín přes rezervační systém. Umyj si vlasy 4-2 dny před procedurou (pokud se ti vlasy hodně mastí, klidně je umyj den předem). V případě dotazů se na nás obraceje do zpráv na IG, FB, e-mail nebo tel.",
		},
		{
			step: "KROK 2",
			heading: "BĚHEM PROCEDURY",
			text: "Přijď max. 5 minut předem. Začínáme diagnostikou pokožky hlavy a vlasů (mikrokamera + rozhovor). Následuje péče a relaxace na lehátku, závěrečný odpočinek s turbanem a vyfoukání vlasů.",
		},
		{
			step: "KROK 3",
			heading: "PO PROCEDUŘE",
			text: "Máš možnost zakoupit si vlasové produkty, které ti doporučíme dle tvých individuálních potřeb. Odcházíš odpočatý s čistou hlavou domů.",
		},
	];

	const voucherHeader = "Jak to funguje";
	const voucherSteps: Step[] = [
		{
			step: "KROK 1",
			heading: "Objednávka poukazu",
			text: "",
		},
		{
			step: "KROK 2",
			heading: "Dárkový poukaznl[[]]nebo online kódík?",
			text: "Vyzvednete si v domluvený čas na pobočce nebo zašleme emailem",
		},
		{
			step: "KROK 3",
			heading: "Využitínl[[]]poukazu",
			text: "Předáte jako dáreček, při objednávce ohlašte platbu dárkovým poukazem",
		},
	];

	const images = [
		{ sm: image1Sm, lg: image1Lg },
		{ sm: image2Sm, lg: image2Lg },
		{ sm: image3Sm, lg: image3Lg },
	];
</script>

<section class="full-width flex flex-col items-center gap-8 md:gap-16 px-4 lg:px-0">
	<h2>
		<Formatted text={style === "booking" ? bookingHeader : voucherHeader} />
	</h2>

	<div class="flex flex-col xl:flex-row items-center xl:items-start w-full max-w-[74rem] px-4 lg:px-0">
		{#each style === "booking" ? bookingSteps : voucherSteps as step, index (index)}
			<div class="flex flex-col items-center gap-4 md:gap-6 w-full md:max-w-[28rem] xl:max-w-none xl:w-[22.5rem]">
				<div class="flex flex-col items-center gap-3 md:gap-4">
					{#if images[index]}
						<Media
							sourcesets={{
								">lg": images[index].lg,
							}}
							source={{ src: images[index].sm, type: "image/webp" }}
							alt=""
							width={500}
							height={500}
							class="w-16 h-16 md:w-20 md:h-20 xl:w-24 xl:h-24 rounded-full object-cover"
						/>
					{:else}
						<div class="w-16 h-16 md:w-20 md:h-20 xl:w-24 xl:h-24 bg-ivory-100 rounded-full"></div>
					{/if}

					<span
						class="w-full text-center font-bold text-[10px] md:text-xs tracking-[0.2em] md:tracking-[0.33em] text-hazelnut-400 uppercase"
					>
						<Formatted text={step.step} />
					</span>
				</div>

				<div class="flex flex-col items-start gap-2 w-full">
					<span class="w-full font-bold text-base md:text-md text-center text-hazelnut-500">
						<Formatted text={step.heading} />
					</span>

					{#if step.text}
						<p
							class="w-full text-text-mobile md:text-p leading-[140%] px-4 sm:px-0 font-normal text-center text-midnight"
						>
							<Formatted text={step.text} />
						</p>
					{/if}
				</div>
			</div>

			{#if index < (style === "booking" ? bookingSteps : voucherSteps).length - 1}
				<div
					class="flex flex-row xl:flex-col justify-center items-center w-full xl:w-[8.25rem] h-8 xl:h-24 xl:grow my-4 xl:my-0"
				>
					<div class="w-full h-0 border-t-2 xl:border-t-2 border-l-2 xl:border-l-0 border-ivory-400"></div>
				</div>
			{/if}
		{/each}
	</div>

	<div class="flex flex-col md:flex-row gap-2 md:gap-4 justify-center items-center">
		<Link
			href="https://head-spa-na-pohodu.reservio.com/"
			target="_blank"
			variant={ButtonVariant.PrimaryMedium}
			iconStart={calendarIcon}>rezervovat termín</Link
		>
		<Link href="/procedury" variant={ButtonVariant.SecondaryMedium} iconStart={couchIcon}>vybrat proceduru</Link>
	</div>
</section>
